import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_3 = { class: "text-catering-ink-700" }
const _hoisted_4 = {
  key: 0,
  class: "text-catering-ink-400"
}
const _hoisted_5 = {
  key: 0,
  class: "shrink-0 font-semibold tabular-nums text-catering-ink-900"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-1 divide-y divide-catering-cream-300"
}
const _hoisted_7 = { class: "min-w-0 truncate" }
const _hoisted_8 = { class: "shrink-0 tabular-nums" }
const _hoisted_9 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-2 flex flex-wrap gap-1"
}

import { computed } from 'vue'

export default {
  __name: 'BotEcommerceOrderSummary',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props
const fulfillmentEntries = computed(() => Object.entries(props.block.fulfillment_status_breakdown || {}))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Orders", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.block.count) + " paid " + _toDisplayString(__props.block.count === 1 ? 'order' : 'orders') + " ", 1),
        (__props.block.days)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "· last " + _toDisplayString(__props.block.days) + " days", 1))
          : _createCommentVNode("", true)
      ]),
      (__props.block.revenue)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.block.revenue), 1))
        : _createCommentVNode("", true)
    ]),
    ((__props.block.per_store || []).length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.per_store, (s, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "flex items-center justify-between py-1 text-catering-ink-900"
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(s.store_name), 1),
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode(_toDisplayString(s.count) + " ", 1),
                (s.revenue)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "· " + _toDisplayString(s.revenue), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (fulfillmentEntries.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fulfillmentEntries.value, (e, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
            }, _toDisplayString(e[0]) + ": " + _toDisplayString(e[1]), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}